import { Badge } from "../components/Shared";

const IMPACT_TONE = { LOW: "neutral", MEDIUM: "warning", HIGH: "signal", CRITICAL: "signal" };
const STATUS_TONE = {
  PENDING_REVIEW: "warning", APPROVED: "forest", IMPLEMENTED: "forest",
  REJECTED: "signal", ROLLED_BACK: "neutral", DRAFT: "neutral",
  OPEN: "warning", ADDRESSED: "forest",
};
const CATEGORY_TONE = { BUSINESS_RULE: "signal", TECHNICAL: "warning", TOOL: "warning" };

export function ImpactBadge({ value }) {
  return <Badge tone={IMPACT_TONE[value] || "neutral"}>{value || "—"}</Badge>;
}
export function StatusBadge({ value }) {
  return <Badge tone={STATUS_TONE[value] || "neutral"}>{(value || "").replace(/_/g, " ") || "—"}</Badge>;
}
export function CategoryBadge({ value }) {
  return <Badge tone={CATEGORY_TONE[value] || "neutral"}>{value || "—"}</Badge>;
}
export function ProtectedBadge() {
  return <Badge tone="signal">Regla protegida</Badge>;
}
